import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { BoxTitle } from 'components/ToggleBox';

export const StyledRadio = styled.div`
  margin-top: 0.5rem;
  width: 86.4rem;
`;

export const TokenTextWrapper = styled.div`
  color: ${getColor('shuttleGray')};
  padding-top: 1rem;
  padding-bottom: 1rem;
  font-size: 1.2rem;
  cursor: default;
  p > span {
    color: ${getColor('chambray')};
    cursor: pointer;
  }
`;

export const StyledFiltersSection = styled.div`
  & ${BoxTitle} {
    background-color: ${getColor('zircon')};
    &:hover {
      background-color: ${getColor('titanWhite')};
    }
  }
  margin-bottom: 1rem;
`;
